import React, { ReactElement } from 'react'
import { TIconComponent } from 'transfix-icons/types'
import { TIconColor, TIconSize } from 'transfix-ui/components/SvgIcon/types'
import { Typography, makeStyles } from 'transfix-ui/core'

const useMergeDetailsListItemStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}))

interface IMergeDetailsListItemProps {
  Icon: TIconComponent
  label: string | ReactElement
  iconColor: TIconColor
  iconSize?: TIconSize
}

export const MergeDetailsListItem = ({
  Icon,
  iconColor,
  iconSize = 'large',
  label,
}: IMergeDetailsListItemProps) => {
  const classes = useMergeDetailsListItemStyles()
  return (
    <div className={classes.root}>
      <Icon color={iconColor} size={iconSize} />
      <Typography variant='body2'>{label}</Typography>
    </div>
  )
}
